var ProductVariationSelectComponent = {
    props: ['variation'],
    methods: {
        changeVariationValue: function (variationValue) {
            var $this = this;

            this.$emit('changeProductVariation', { variationId: this.variation.id, variationValue: variationValue });

            this.$parent.changeProductVariation(this.variation.id, variationValue, function (data) {
                $this.selected = variationValue;
            }, function (data) {
                Event.dispatch('Product.variationChangeFailed', {
                    'product': $this.$parent.product,
                    'response': data
                });
            });
        }
    },
    data: function () {
        return {
            selected: this.$parent.product.selected_variation_values[this.variation.id],
            variationValues: _.sortBy(this.$parent.product.variation_values[this.variation.id], function (variationValue) {
                return parseInt(variationValue.sort_variation) || 1
            }),
            product: this.$parent.product
        };
    },
    mounted: function () {
        this.$nextTick(function () {
            Event.dispatch('Product.variationMounted');
        });
    },
    watch: {
        'product.selected_variation_values': {
            handler: function (val) {
                this.selected = val[this.variation.id]
            },
            deep: true
        }
    }
};

if (typeof CustomProductVariationSelectComponent !== 'undefined') {
    ProductVariationSelectComponent = { ...ProductVariationSelectComponent, ...CustomProductVariationSelectComponent };
}

var ProductVariationComponent = Vue.component('product-variation', {
    props: [],
    data: function () {
        return {
            product: this.$parent.product,
            product_id: this.$parent.product.id,
            product_variation_id: this.$parent.product.first_variation.id
        }
    },
    methods: {
        changeProductVariation: function (variationId, variationValue, successCallback, errorCallback) {
            var variationValues = _.clone(this.product.selected_variation_values);

            if (variationValues[variationId] == variationValue || (variationValues[variationId] && variationValues[variationId].id == variationValue.id)) {
                return;
            }

            variationValues[variationId] = variationValue;

            Event.dispatch('Before::Product.variationChange', {
                'product': this.$parent.product,
                'variationId': variationId,
                'variationValue': variationValue
            });

            this.fetch('post', 'catalog/get-product-variation/' + this.product.id, {
                changed_value: variationValue ? variationValue.id : null,
                variation_values: _.pluck(variationValues, 'id'),
                product_set_id: this.product.product_set_id
            }, function (data) {
                if (!data.status) {
                    this.$parent.product.product_variation_id = null;
                    errorCallback(data);

                    return;
                }

                this.$parent.product.product_variation_id = data.item.id;
                this.$parent.product.model = data.item.model;
                this.$parent.product.name = data.item.name;
                this.$parent.product.price = data.item.price;
                this.$parent.product.price_vat = data.item.price_vat;
                this.$parent.product.old_price = data.item.old_price;
                this.$parent.product.old_price_vat = data.item.old_price_vat;
                this.$parent.product.image = data.item.image_raw;
                this.$parent.product.status = data.item.status;
                this.$parent.product.status_color = data.item.status_color;
                this.$parent.product.status_description = data.item.status_description;
                this.$parent.product.is_available = data.item.is_available;

                this.$parent.product.selected_variation_values = {};

                for (var i = 0; i < data.variation.variation_values.length; i++) {
                    var variationValue = data.variation.variation_values[i];
                    this.$parent.product.selected_variation_values[variationValue.variation_id] = variationValue;
                }

                successCallback(data);

                Event.dispatch('Product.variationChanged', {
                    'product': this.$parent.product,
                    'response': data,
                    'component': this
                });

                this.$emit('update', {
                    product: this.$parent.product,
                    productVariation: data.item,
                    response: data
                })
            }.bind(this), {
                errorCallback: function (jqXHR, textStatus, errorThrown) {
                    Event.dispatch('Product.variationChangeError', {
                        'product': this.$parent.product,
                        'jqXHR': jqXHR,
                        'textStatus': textStatus,
                        'errorThrown': errorThrown
                    });
                }.bind(this)
            });

            return true;
        }
    },
    components: {
        'variation-select': ProductVariationSelectComponent
    }
});
